module.exports = __webpack_public_path__ + "static/img/lrs_nvwu_img@2x.4bc61ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_nvwu_img@2x.png
// module id = 1dn4
// module chunks = 23